import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotCamera = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Property_1=on,_Property_2=40_svg__a)">
            <path
                fill={spotColor}
                fillRule="evenodd"
                d="M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z"
                clipRule="evenodd"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M38.335 31.667A3.333 3.333 0 0 1 35 35h-30a3.333 3.333 0 0 1-3.333-3.333V13.333A3.333 3.333 0 0 1 5.001 10h6.667l3.333-5h10l3.334 5H35a3.333 3.333 0 0 1 3.334 3.333v18.334Z"
            />
            <path
                stroke="#13126C"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.2}
                d="M20 28.333A6.667 6.667 0 1 0 20 15a6.667 6.667 0 0 0 0 13.333Z"
            />
        </g>
        <defs>
            <clipPath id="Property_1=on,_Property_2=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotCamera.displayName = "SpotCamera";
